// extracted by mini-css-extract-plugin
export default {"footer":"CreateMarketingMaterialDrawer_footer__vfbx-"};